import Axios from 'axios';
import Qs from 'qs';

export default {

  // 费项分页列表
  listPage(
    keyword,
    expenses_type_id,
    community_id,
    page,
    per_page
  ) {
    return Axios.get('/shjf/api/admin/charges', {
      params: {
        keyword,
        expenses_type_id,
        community_id,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 费项列表
  list(
    community_ids
  ) {
    return Axios.get('/shjf/api/admin/charges/list', {
      params: {
        community_ids
      }
    })
  },

  // 费项添加
  add(
    name,
    community_ids,
    expenses_type_id,
    formula_id,
    price,
    billing_cycle_type,
    billing_cycle_date,
    has_late_fee,
    late_fee_percent,
    late_fee_cycle,
    late_fee_start_day
  ) {
    return Axios.post('/shjf/api/admin/charges', {
      name,
      community_ids,
      expenses_type_id,
      formula_id,
      price,
      billing_cycle_type,
      billing_cycle_date,
      has_late_fee,
      late_fee_percent,
      late_fee_cycle,
      late_fee_start_day
    });
  },

  // 费项编辑
  edit(
    id,
    name,
    community_ids,
    expenses_type_id,
    formula_id,
    price,
    billing_cycle_type,
    billing_cycle_date,
    has_late_fee,
    late_fee_percent,
    late_fee_cycle,
    late_fee_start_day
  ) {
    return Axios.put(`/shjf/api/admin/charges/${id}`, {
      name,
      community_ids,
      expenses_type_id,
      formula_id,
      price,
      billing_cycle_type,
      billing_cycle_date,
      has_late_fee,
      late_fee_percent,
      late_fee_cycle,
      late_fee_start_day
    });
  },

  // 费项删除
  del(
    id
  ) {
    return Axios.delete(`/shjf/api/admin/charges/${id}`);
  },

  // 费项详情
  info(
    id
  ) {
    return Axios.get(`/shjf/api/admin/charges/${id}`);
  },

  // 费项设置
  settings(
    community_ids,
    building_ids,
    door_ids,
    floor_ids,
    house_ids,
    charges_id,
    start_date,
    end_date
  ) {
    return Axios.post('/shjf/api/admin/charges/setting/multi', {
      community_ids,
      building_ids,
      door_ids,
      floor_ids,
      house_ids,
      charges_id,
      start_date,
      end_date
    });
  },

  // 修改费项设置
  editSettings(
    id,
    end_date
  ) {
    return Axios.put(`/shjf/api/admin/charges/setting/${id}`, {
      end_date
    });
  },

  // 修改费项设置
  settingsInfo(
    id
  ) {
    return Axios.get(`/shjf/api/admin/charges/setting/${id}`);
  },

  // 房屋费项列表
  houseExpendList(
    id
  ) {
    return Axios.get(`/shjf/api/admin/house/${id}/charges`);
  },

  // 应收订单分页列表
  orderListPage(
    keyword,
    charges_id,
    order_status,
    community_id,
    build_id,
    door_id,
    floor_id,
    houses_id,
    page,
    per_page
  ) {
    return Axios.get('/shjf/api/admin/order', {
      params: {
        keyword,
        charges_id,
        order_status,
        community_id,
        build_id,
        door_id,
        floor_id,
        houses_id,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 订单催缴
  orderSettingsOne(
    order_ids
  ) {
    return Axios.put('/shjf/api/admin/order/urge/multi', {
      order_ids
    });
  },

  // 订单设为已缴
  orderSettingsTwo(
    id,
    pay_price,
    pay_type,
    pay_name,
    remark
  ) {
    return Axios.put(`/shjf/api/admin/order/${id}/setPay`, {
      pay_price,
      pay_type,
      pay_name,
      remark
    });
  },

  // 修改订单
  orderSettingsThree(
    id,
    price,
    price_change_remark
  ) {
    return Axios.put(`/shjf/api/admin/order/${id}`, {
      price,
      price_change_remark
    });
  },

  // 订单作废
  orderSettingsFour(
    id,
    invalid_remark
  ) {
    return Axios.put(`/shjf/api/admin/order/${id}/invalid`, {
      invalid_remark
    });
  },

  // 订单接口
  orderInfo(
    id
  ) {
    return Axios.get(`/shjf/api/admin/order/${id}`);
  },

  // 导出
  exportList(
    keyword,
    charges_id,
    order_status,
    community_id,
    build_id,
    door_id,
    floor_id,
    houses_id
  ) {
    return Axios.get('/shjf/api/admin/order-explode', {
      params: {
        keyword,
        charges_id,
        order_status,
        community_id,
        build_id,
        door_id,
        floor_id,
        houses_id
      },
      responseType: 'blob'
    });
  }

}